// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import moment from 'moment';
import { ActionCell } from './ActionCell'


const orderListColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Device Id' className='min-w-50px' />
    ),
    id: 'deviceId',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.deviceId} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='ean' className='min-w-50px' />
    ),
    id: 'ean',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.ean} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Quantità letta' className='min-w-50px' />
    ),
    id: 'consumedQuantity',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.consumedQuantity} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Data lettura' className='min-w-50px' />
    ),
    id: 'updatedAt',
    Cell: ({ ...props }) => <TitleCell userObj={moment(props.data[props.row.index]?.updatedAt).format("YYYY-MM-DD")} />,
  },
]

export { orderListColumns }
